import React from 'react';
import { ScrollView, View, type ScrollViewProps } from 'react-native';

type DefaultScreenContainerProps = {
  children: React.ReactNode;
  className?: string;
  isScrollView?: true;
} & ScrollViewProps;

const DefaultScreenContainer: React.FC<DefaultScreenContainerProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <View className="flex-1 bg-light-100">
      <ScrollView
        className={`flex-1 bg-light-100 container mx-auto max-w-5xl ${className}`}
        {...rest}
      >
        {children}
      </ScrollView>
    </View>
  );
};

export default DefaultScreenContainer;
